import { render, staticRenderFns } from "./insured.vue?vue&type=template&id=3b43ed3b&"
import script from "./insured.vue?vue&type=script&lang=js&"
export * from "./insured.vue?vue&type=script&lang=js&"
import style0 from "./insured.vue?vue&type=style&index=0&id=3b43ed3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports